import api from '../../../api/content';

const create = ({ commit }, data) => {
  commit('setLoadingFlag', true);
  return api.create(data).then(blogPost => {
    commit('setBlogPost', blogPost);
    commit('setLoadingFlag', false);
    return blogPost;
  });
};

const fetch = ({ commit }, type) => {
  commit('setLoadingFlag', true);
  return api.fetch(type).then(blogPosts => {
    commit('setBlogPosts', blogPosts);
    commit('setLoadingFlag', false);
    return blogPosts;
  });
};

const get = ({ commit }, id) => {
  return api.get(id).then(blogPost => {
    commit('setBlogPost', blogPost);
    return blogPost;
  });
};

const update = ({ commit }, data) => {
  commit('setLoadingFlag', true);
  return api.update(data).then(blogPost => {
    commit('setBlogPost', blogPost);
    commit('setLoadingFlag', false);
    return blogPost;
  });
};

export { create, fetch, get, update };
